<form [formGroup]="priceForm" (ngSubmit)="onSubmit()">

  <!-- Price Fields -->
  <div fxLayout="row wrap" >
    <ng-container *ngFor="let field of ['free', 'std', 'pro', 'ent', 'u']">
      <div fxFlex="20">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{ field | titlecase }} Price Annual</mat-label>
          <input [attr.guide]="'price-table-plan6-inp-1' + '__' + sanitizeUrl(url)" matInput [formControlName]="field + '_charge_year'" />
        </mat-form-field>
      </div>
    </ng-container>

    <ng-container *ngFor="let field of ['free', 'std', 'pro', 'ent', 'u']">
      <div fxFlex="20">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{ field | titlecase }} Price Monthly</mat-label>
          <input [attr.guide]="'price-table-plan6-inp-2' + '__' + sanitizeUrl(url)" matInput [formControlName]="field + '_charge_month'" />
        </mat-form-field>
      </div>
    </ng-container>
  </div>

  <!-- Pricing Details Array -->
  <div formArrayName="pricedetail">
    <div *ngFor="let detail of pricedetail.controls; let i = index" [formGroupName]="i" style="margin-top: 15px; border: 1px solid #ddd; padding: 10px;">

      <!-- Title -->
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="70">
          <mat-label>Title</mat-label>
          <input [attr.guide]="'price-table-plan6-inp-title' + '__' + sanitizeUrl(url)" matInput formControlName="title" />
        </mat-form-field>
        <button [attr.guide]="'price-table-plan6-btn-3' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deletePricingDetail(i)">Delete</button>
      </div>

      <!-- List Detail -->
      <div formArrayName="list_detail">
        <div *ngFor="let item of detail.get('list_detail').controls; let j = index" [formGroup]="item" style="margin: 10px 0; padding: 10px; border: 1px dashed gray;">
          <div fxLayout="row wrap" fxLayoutGap="10px">
            <mat-form-field fxFlex="20">
              <mat-label>Sub title</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-sub-title' + '__' + sanitizeUrl(url)" matInput formControlName="sub_title" />
            </mat-form-field>
            <mat-form-field fxFlex="20">
              <mat-label>Free</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-id-element' + '__' + sanitizeUrl(url)" matInput formControlName="id_element" />
            </mat-form-field>            
            <mat-form-field fxFlex="20">
              <mat-label>Starter</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-starter' + '__' + sanitizeUrl(url)" matInput formControlName="starter" />
            </mat-form-field>
            <mat-form-field fxFlex="20">
              <mat-label>Profession</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-profession' + '__' + sanitizeUrl(url)" matInput formControlName="profession" />
            </mat-form-field>
            <mat-form-field fxFlex="20">
              <mat-label>EnterPrise</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-advanced' + '__' + sanitizeUrl(url)" matInput formControlName="advanced" />
            </mat-form-field>
            <!-- <mat-form-field fxFlex="20">
              <mat-label>Navigation</mat-label>
              <mat-select formControlName="navigation">
                <mat-option *ngFor="let item of navigation" [value]="item.value">{{ item.viewValue }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="20" *ngIf="item.get('navigation')?.value === 1">
              <mat-label>Button Link</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-button-link' + '__' + sanitizeUrl(url)" matInput formControlName="button_link" />
            </mat-form-field>
            <mat-form-field fxFlex="20" *ngIf="item.get('navigation')?.value === 0">
              <mat-label>ID Element</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-id-element' + '__' + sanitizeUrl(url)" matInput formControlName="id_element" />
            </mat-form-field>
            <mat-form-field fxFlex="20" *ngIf="item.get('navigation')?.value === 2">
              <mat-label>Dynamic Form</mat-label>
              <mat-select formControlName="value">
                <mat-option>
                  <ngx-mat-select-search [formControl]="dynamicFormFilterControl" placeholderLabel="Search" noEntriesFoundLabel="No results found"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filtereddynamicFormTypeList" [value]="opt.formGroupId">{{ opt.name }}</mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field fxFlex="20">
              <mat-label>Ultimater</mat-label>
              <input [attr.guide]="'price-table-plan6-inp-table-color' + '__' + sanitizeUrl(url)" matInput formControlName="table_color" />
            </mat-form-field>
            <button [attr.guide]="'price-table-plan6-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deleteListDetail(i, j)">Delete Row</button>
          </div>
        </div>

        <button [attr.guide]="'price-table-plan6-btn-5' + '__' + sanitizeUrl(url)" mat-raised-button color="accent" (click)="addListDetail(i)">Add List Detail</button>
      </div>
    </div>

    <br />
    <button [attr.guide]="'price-table-plan6-btn-6' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="addPricingDetails()">Add Pricing Detail</button>
  </div>

  <br />
  <button [attr.guide]="'price-table-plan6-btn-7' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" type="submit">{{ btntext }}</button>
</form>
